export const stringToNumber = (value: string) => {
  const normalizedValue = value.trim()
  if (!normalizedValue) return 0

  // Keep support limited to digits, sign and dot/comma separators.
  if (!/^[+-]?[\d.,]+$/.test(normalizedValue)) return 0

  const sign = normalizedValue.startsWith('-') ? '-' : ''
  const unsignedValue = normalizedValue.replace(/^[+-]/, '')
  const lastDotIndex = unsignedValue.lastIndexOf('.')
  const lastCommaIndex = unsignedValue.lastIndexOf(',')
  const decimalSeparator = lastDotIndex > lastCommaIndex ? '.' : (lastCommaIndex > -1 ? ',' : '')

  const numberAsString = !decimalSeparator
    ? unsignedValue.replace(/[.,]/g, '')
    : (() => {
      const parts = unsignedValue.split(decimalSeparator)
      const decimalPart = parts.pop() ?? ''
      const integerPart = parts.join('').replace(/[.,]/g, '')
      return `${integerPart}.${decimalPart}`
    })()

  if (!/^\d+(\.\d+)?$/.test(numberAsString)) return 0

  const parsedValue = Number(`${sign}${numberAsString}`)
  return Number.isFinite(parsedValue) ? parsedValue : 0
}